// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202609142339/js/" + chunkId + "." + {"44":"cc4204f4","225":"b4ce5ed2","481":"b3a22614","486":"912975c7","770":"2c89dda4"}[chunkId] + ".0.006187982518445989.chunk.js";
};